import React, { useRef, useState, useEffect } from "react";
import { motion, useMotionValue, animate } from "framer-motion";
import "./One.css";
import front from "../../assets/nfc1.png";
import back from "../../assets/nfc2.png";
import o1 from "../../assets/o1.svg";
import o2 from "../../assets/o2.svg";
import o3 from "../../assets/o3.svg";
import o4 from "../../assets/o4.svg";
import o5 from "../../assets/o5.svg";
import o6 from "../../assets/o6.svg";
import o7 from "../../assets/o7.svg";
import o8 from "../../assets/o8.svg";
import curve from "../../assets/curve.png";
import ripple from "../../assets/rcircle.png";
import ripple2 from "../../assets/rcircle2.png";
import ripple3 from "../../assets/rcircle3.png";
import ripple4 from "../../assets/rcircle4.png";
import ripple5 from "../../assets/rcircle5.png";

const One = () => {
  const data = [
    {
      id: 1,
      img: o1,
      title: "Available Globally",
      subtitle: "Works across languages, time zones, and borders.",
    },
    {
      id: 2,
      img: o2,
      title: "Share with Everyone",
      subtitle: "Instantly connect with clients, colleagues, and prospects.",
    },
    {
      id: 3,
      img: o3,
      title: "Customizable Profiles",
      subtitle: "Add your branding, portfolio, and contact details.",
    },
    {
      id: 4,
      img: o4,
      title: "QR Code Enabled",
      subtitle: "Share digitally in seconds with a quick scan.",
    },
    {
      id: 5,
      img: o5,
      title: "Seamless Integration",
      subtitle: "Works with your digital tools and workflows.",
    },
    {
      id: 6,
      img: o6,
      title: "Always Up-to-Date",
      subtitle: "Update your info anytime, changes sync instantly.",
    },
    {
      id: 7,
      img: o7,
      title: "Sustainability First",
      subtitle: "Eco-friendly NFC cards, cutting 90% plastic waste.",
    },
    {
      id: 8,
      img: o8,
      title: "Dedicated Support",
      subtitle: "Expert help and assistance whenever you need it.",
    },
  ];

  const containerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [contentWidth, setContentWidth] = useState(0);
  const [isDragging, setIsDragging] = useState(false);

  const x = useMotionValue(0);
  const [autoPlay, setAutoPlay] = useState(true);

  // Calculate widths on mount and resize
  useEffect(() => {
    const updateWidths = () => {
      if (containerRef.current) {
        const container = containerRef.current;
        const containerRect = container.getBoundingClientRect();
        setContainerWidth(containerRect.width);

        // Calculate content width (assuming each item is ~300px + margins)
        const itemWidth = 320; // Approximate width including margins
        setContentWidth(data.length * itemWidth);
      }
    };

    updateWidths();
    window.addEventListener("resize", updateWidths);
    return () => window.removeEventListener("resize", updateWidths);
  }, [data.length]);

  // Auto-scroll animation
  useEffect(() => {
    if (!autoPlay || isDragging || !contentWidth || !containerWidth) return;

    const controls = animate(x, -contentWidth, {
      duration: 80,
      ease: "linear",
      repeat: Infinity,
      onUpdate: (latest) => {
        // Reset to start when reaching the end
        if (latest <= -contentWidth) {
          x.set(0);
        }
      },
    });

    return controls.stop;
  }, [autoPlay, isDragging, contentWidth, containerWidth, x]);

  const handleDragStart = () => {
    setIsDragging(true);
    setAutoPlay(false);
  };

  const handleDragEnd = () => {
    setIsDragging(false);

    // Resume auto-play after a delay
    setTimeout(() => {
      setAutoPlay(true);
    }, 2000);
  };

  const maxDrag = containerWidth - contentWidth;
  const minDrag = 0;

  return (
    <div className="containerOne">
      <div className="innerDivOne">
        <div className="upperone">
          <div className="leftone">
            <h1 className="headingOne">
              {" "}
              <span>One Card</span>, Endless Connections
            </h1>
            <p className="paraOne">
              With just one NFC smart card, unlock unlimited networking
              possibilities. Instantly share your contact details, social links,
              and business profile—building meaningful connections anytime,
              anywhere, with zero hassle.
            </p>
          </div>
          <div className="rightone">
            <img src={front} alt="" className="frontimg" />
            <img src={back} alt="" className="backimg" />
            <img src={ripple4} alt="" className="rippleimg" />
            <img src={ripple4} alt="" className="rippleimg" />
            <img src={ripple3} alt="" className="rippleimg" />
            <img src={ripple2} alt="" className="rippleimg" />
            <img src={ripple} alt="" className="rippleimg" />
          </div>
        </div>

        <div
          className="lowerone"
          ref={containerRef}
          style={{
            overflow: "hidden",
            cursor: isDragging ? "grabbing" : "grab",
          }}
        >
          <motion.div
            style={{
              x,
              display: "flex",
              width: "max-content",
              alignItems: "stretch",
            }}
            drag="x"
            dragConstraints={{
              left: maxDrag,
              right: minDrag,
            }}
            dragElastic={0.1}
            onDragStart={handleDragStart}
            onDragEnd={handleDragEnd}
            whileDrag={{ cursor: "grabbing" }}
          >
            {/* Render items twice for seamless loop */}
            {[...data, ...data, ...data].map((item, index) => (
              <div
                key={`${item.id}-${Math.floor(index / data.length)}`}
                className={`loweroneItem loweritem${item.id}`}
                style={{
                  minWidth: "300px",
                  marginRight: "20px",
                  userSelect: "none",
                  height: "auto",
                }}
              >
                <img
                  src={item.img}
                  alt={item.title}
                  className="loweritemimg"
                  draggable={false}
                />
                <h3 className="loweritemtitle">{item.title}</h3>
                <p className="loweritemsubtitle">{item.subtitle}</p>
              </div>
            ))}
          </motion.div>
        </div>

        <img src={curve} alt="" className="curveimg" />
      </div>
    </div>
  );
};

export default One;
